import React, { Component } from "react";
import TextField from '@material-ui/core/TextField';
import SessionStateManager from "@components/SessionStateManager";
import ValidationsManager from "@components/ValidationsManager";
import UpdateDialog from '@components/UpdateDialog';
import SupportAlert from "@components/SupportAlert";
import { CustomDialog, useDialog } from 'react-st-modal';
import styles from '../questionnaire.module.css';

class ForeignSourcesOfFundsQuestion extends Component {
    state = {
        loading: true,
        sessionStateChanged: false,
        topLeftTitle: 'Funding of R&D from the rest of the world',
        topTitle: 'PERCENTAGE OF EXPENDITURE',
        totalLabel: 'TOTAL must sum to 100% (of total funding from rest of the world Q12)',
    }

    constructor(props) {
        super(props);
    }

    async componentDidMount() {
        this.setState({ loading: true });

        if (this.props.sectorId == 2) {
            if (this.props.questionState.name.toUpperCase().includes('FOREIGN SOF')) {
                this.setState({ topLeftTitle: 'Funding of R&D from the rest of the world' });
                this.setState({ topTitle: 'PERCENTAGE OF EXPENDITURE' });
                this.setState({ totalLabel: 'TOTAL must sum to 100% (of total funding from rest of the world Q8)' });
            }

            if (this.props.questionState.name.toUpperCase().includes('Outsourced outside South Africa'.toUpperCase())) {
                this.setState({ topLeftTitle: '' });
                this.setState({ topTitle: 'PERCENTAGE EXTRAMURAL R&D OUTSIDE SOUTH AFRICA' });
                this.setState({ totalLabel: 'TOTAL must sum to 100% of total extramural R&D outside SA R&D (Q17a)' });
            }
        }

        this.setState({ loading: false });
    }

    async handleOnChange(evt) {
        let key = evt.target.attributes.questionFactId.value + '_' + evt.target.attributes.ordinalEntry.value;
        let value = evt.target.value;

        if (this.props.captureType !== undefined && this.props.captureType != null && this.props.captureType == 'RESEARCHER_UPDATE') {
            const result = await CustomDialog(
                <UpdateAuditDialog
                    currentAnswer={SessionStateManager.getSessionValue(key)}
                    numericInput={true}
                />,
                {
                    className: styles.updateAuditDialog,
                    title: 'Update Submitted Value',
                    showCloseIcon: false,
                    isFocusLock: true,
                    isCanClose: true, // setting this to false prevents the dialog from being closed when clicking away
                }
            );

            if (result !== undefined && result != null && result.confirmed !== undefined && result.confirmed != null && result.confirmed == true) {
                SessionStateManager.setSessionValue(key, result.newValue, this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId, result.sourceOfData, result.reason);
                this.setState({ sessionStateChanged: true });
            } else {
                evt.preventDefault();
            }
        } else {
            SessionStateManager.setSessionValue(key, value, this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId, "", "");
            this.setState({ sessionStateChanged: true });
        }

        if (this.props.onChange !== undefined && this.props.onChange != null) {
            this.props.onChange(evt);
        }
    }

    handleOnBlur = (evt) => {
        if (this.props.onBlur !== undefined && this.props.onBlur != null) {
            this.props.onBlur(evt);
        }
    }

    render() {
        if (this.state.loading === true) {
            return <p>Loading...</p>
        } else {
            return <div className={styles.foreignSOFQuestionContainer}>
                <table className="table">
                    <thead>
                        <tr>
                            <th>{this.state.topLeftTitle}</th>
                            <th colSpan={[...new Set(this.props.questionState.questionFactStates.map((item) => item.sequenceNumberY))].length}>{this.state.topTitle}</th>
                        </tr>
                        <tr>
                            <th>Category</th>
                            {[...new Set(this.props.questionState.questionFactStates
                                .map((item) => item.sequenceNumberY))]
                                .sort()
                                .map(columnIndex => <th>{this.props.questionState.questionFactStates
                                    .filter(questionFactState => questionFactState.sequenceNumberY == columnIndex)[0]
                                    .columnDimensionStates
                                    .filter(item => !item.dimensionAlias.toUpperCase().includes('COUNTRY GROUP'))[0].dimensionAlias}
                                </th>
                                )
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {[...new Set(this.props.questionState.questionFactStates
                            .filter(questionFactState => !questionFactState.rowDimensionStates[0].dimensionAlias.toUpperCase().includes('TOTAL'))
                            .map((item) => item.sequenceNumberX))]
                            .sort()
                            .map(rowIndex =>
                                <tr>
                                    <th>{this.props.questionState.questionFactStates
                                        .filter(questionFactState => questionFactState.sequenceNumberX == rowIndex)[0].rowDimensionStates[0].dimensionAlias}
                                    </th>
                                    {this.props.questionState.questionFactStates
                                        .filter(questionFactState => questionFactState.sequenceNumberX == rowIndex)
                                        .sort((a, b) => a.sequenceNumberY > b.sequenceNumberY ? 1 : -1)
                                        .map(questionFactState => {
                                            if (questionFactState.columnDimensionStates.some(columnDimensionState => columnDimensionState.dimensionAlias.toUpperCase().includes('DATA CHECK'))) {
                                                return <td className={styles.noClickBox} >
                                                    <div className={styles.percentage}>
                                                        <input
                                                            className={ValidationsManager.hasValueBeenUpdated(this.props.captureType, questionFactState.questionFactId + '_0') ? styles.tableTotalCellUpdated : styles.tableTotalCell}
                                                            min='0'
                                                            max='100'
                                                            type="text"
                                                            id="z1"
                                                            value={SessionStateManager.getSessionValue(questionFactState.questionFactId + '_0')}
                                                            questionId={this.props.questionState.question.id}
                                                            ordinalEntry={0}
                                                            questionFactId={questionFactState.questionFactId}
                                                            placeholder='0'
                                                            readOnly
                                                        />
                                                    </div>
                                                </td>
                                            } else {
                                                return <td
                                                    className={ValidationsManager.hasValueBeenUpdated(this.props.captureType, questionFactState.questionFactId + '_0') ? styles.tableInputBoxUpdated : null}
                                                >
                                                    <div className={styles.percentage}>
                                                        <input
                                                            className={ValidationsManager.hasValueBeenUpdated(this.props.captureType, questionFactState.questionFactId + '_0') ? styles.tableInputBoxUpdated : styles.tableInputBox}
                                                            min='0'
                                                            max='100'
                                                            type="text"
                                                            id="z2"
                                                            questionId={this.props.questionState.question.id}
                                                            ordinalEntry={0}
                                                            questionFactId={questionFactState.questionFactId}
                                                            placeholder='0'
                                                            value={SessionStateManager.getSessionValue(questionFactState.questionFactId + '_0')}
                                                            onClick={(evt) => {
                                                                if (this.props.captureType !== undefined && this.props.captureType !== null && this.props.captureType == 'RESEARCHER_UPDATE') {
                                                                    this.handleOnChange(evt);
                                                                }
                                                            }}
                                                            onKeyPress={(event) => { if (!/[0-9|\.]/.test(event.key) || (this.props.captureType !== undefined && this.props.captureType !== null && this.props.captureType == 'RESEARCHER_UPDATE')) { event.preventDefault(); } }}
                                                            onChange={(evt) => this.handleOnChange(evt)}
                                                            onBlur={this.handleOnBlur}
                                                        />
                                                    </div>
                                                </td>
                                            }
                                        })
                                    }
                                </tr>
                            )
                        }
                        {[...new Set(this.props.questionState.questionFactStates
                            .filter(questionFactState => questionFactState.rowDimensionStates[0].dimensionAlias.toUpperCase().includes('TOTAL'))
                            .map((item) => item.sequenceNumberX))]
                            .sort()
                            .map(rowIndex =>
                                <tr>
                                    <th>{this.props.questionState.questionFactStates.filter(questionFactState => questionFactState.sequenceNumberX == rowIndex)[0].rowDimensionStates[0].dimensionAlias}</th>
                                    {this.props.questionState.questionFactStates
                                        .filter(questionFactState => questionFactState.sequenceNumberX == rowIndex)
                                        .sort((a, b) => a.sequenceNumberY > b.sequenceNumberY ? 1 : -1)
                                        .map(questionFactState =>
                                            <td
                                                className={ValidationsManager.hasValueBeenUpdated(this.props.captureType, questionFactState.questionFactId + '_0') ? styles.tableTotalCellUpdated : null}
                                            >
                                                <div className={styles.percentage} 
                                                    questionFactId={questionFactState.questionFactId}>
                                                    <TextField
                                                        questionId={this.props.questionState.question.id}
                                                        error={SessionStateManager.getSessionValue(questionFactState.questionFactId + '_0') != 100}
                                                        helperText={SessionStateManager.getSessionValue(questionFactState.questionFactId + '_0') != 100 ? 'Total must sum to 100%' : null}
                                                        type="number"
                                                        id="outlined-error-helper-text"
                                                        size="normal"
                                                        value={SessionStateManager.getSessionValue(questionFactState.questionFactId + '_0')}
                                                        placeholder={0}
                                                        ordinalEntry={0}
                                                        questionFactId={questionFactState.questionFactId}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        readOnly
                                                    />
                                                </div>
                                            </td>
                                        )}
                                    <th colSpan={[...new Set(this.props.questionState.questionFactStates.map((item) => item.sequenceNumberY))].length - 1}>{this.state.totalLabel}</th>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
        }
    }
}
export default ForeignSourcesOfFundsQuestion;

function UpdateAuditDialog(props) {
    const dialog = useDialog();

    let componentRef = null;
    let result = {};
    result.confirmed = false;

    return (
        <div>
            <div
                className={styles.updateAuditDialogOverlay}
                ref={(response) => (componentRef = response)}
            >
                <UpdateDialog
                    {...props}
                    onChangeSourceOfData={(evt, newValue) => {
                        result.newValue = newValue;
                        result.sourceOfData = evt.target.value;
                    }}
                    onChangeReason={(evt, newValue) => {
                        result.newValue = newValue;
                        result.reason = evt.target.value
                    }}
                    onChangeNewValue={(evt) => {
                        result.newValue = evt.target.value
                    }}
                />
            </div>

            <div>
                <button
                    type="button"
                    className="btnBack"
                    onClick={(evt) => {
                        result.confirmed = false;
                        dialog.close(result);
                    }}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    className="btnNext"
                    onClick={(evt) => {
                        if (
                            result.sourceOfData === undefined || result.sourceOfData == null || result.sourceOfData.trim() == "" ||
                            result.reason === undefined || result.reason == null || result.reason.trim() == ""
                        ) {
                            SupportAlert.displayAlert('Required', 'Source of data and Reason are required fields.');
                        } else {
                            result.confirmed = true;
                            dialog.close(result);
                        }
                    }}
                >
                    Continue
                </button>
            </div>
        </div>
    );
}


